<template>
  <HostLayoutContainer class="contact" :style="{height:'820px'}">
    <HostLayoutItem>
      <Title :title="{text: '联系我们', marginTop: '104px', marginBottom: '54px'}" id="contact"/>
      <!--<div class="contact__title">联系我们</div>-->
      <div class="contact__content">
        <div class="contact__cards">
          <div class="contact__card contact__address">
            <div class="contact__card-title">
              <div class="contact__card-title-inner">
                <div>有帮信息科技(北京)有限公司</div>
                <div class="contact__icon"><img src="/assets/about/contact_location@3x.png" alt=""></div>
              </div>
            </div>

            <div class="contact__text">地址：北京市朝阳区将台路甲<br />2号院2号楼1层101号9层902室</div>
            <div class="contact__text">邮编：100016</div>
          </div>
          <div class="contact__card contact__contact-way">

            <div class="contact__card-title">
              <div class="contact__card-title-inner">
                <div>联系我们</div>
                <div class="contact__icon"><img src="/assets/about/contact_ways@3x.png" alt=""></div>
              </div>
            </div>
            <div class="contact__text">
              咨询邮箱：info@ubang.cn <br />
              微软产品与许可咨询 <br />
              销售邮箱：sales@ubang.cn <br />
              电话：+86 186 1010 7700（微信同号） <br />
              市场邮箱：pr@ubang.cn <br />
              招聘邮箱：hr@ubang.cn <br />
            </div>
          </div>
        </div>
        <div class="contact__map">
          <div class="contact__map-image"><img src="/assets/about/contact_map@3x.png" alt=""></div>
        </div>
      </div>
    </HostLayoutItem>
  </HostLayoutContainer>
</template>

<script>
import {defineComponent} from 'vue'
import Title from '@/components/title/title-with-underline.vue'
export default defineComponent({
  components: {Title}
})
</script>

<style lang="scss" scoped>
.contact {
  background-image: url('/assets/solution/banner@3x.png');
  background-position: bottom center;
}

//.contact__title {
//  display: flex;
//  justify-content: center;
//  margin-top: 83px;
//  margin-bottom: 79px;
//
//  font-size: 32px;
//  font-family: PingFangSC-Medium, PingFang SC;
//  font-weight: 500;
//  color: #0D253E;
//  line-height: 45px;
//  letter-spacing: 2px;
//}

.contact .description__title {
  margin-top: 50px;
}

.contact__content {
  display: flex;
  justify-content: space-between;

  padding: 0 40px;
}

/* 卡片宽度由 320px 调整为 336px：新增的「电话：+86 186 1010 7700（微信同号）」
   整行需要 283px，而 320px 卡片去掉左右内边距（32 + 18）只剩 270px 可用，
   会折行且断在括号内部（第二行只剩「号）」）。336px 下可用 286px，该行完整显示。 */
.contact__cards {
  width: 336px;
}

.contact__card {
  overflow: hidden; /* 触发 bfc */
  padding-left: 32px;
  padding-right: 18px;
  height: 227px;
  background: #FFFFFF;
  box-shadow: 0px 0px 13px 3px rgba(0, 0, 0, 0.08);
  border-radius: 20px;
}

.contact__card:last-child {
  margin-top: 48px;
}

/* 联系方式卡片比地址卡片多两行（新增「微软产品与许可咨询」与「电话」），
   沿用 227px 会因 overflow: hidden 把最后一行裁掉，故按真实内容单独定高：
   28(标题上边距) + 22(标题) + 16(正文上边距) + 6×27(六行正文) + 53(底部留白) = 281
   （53px 底部留白与原设计的联系方式卡片保持一致） */
.contact__contact-way {
  height: 281px;
}

.contact__card-title {
  margin-top: 28px;

  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3F4957;
  line-height: 22px;
}

.contact__card-title-inner {
  display: flex;
  align-items: center;
}

.contact__icon {
  margin-left: 10px;
  width: 26px;
  img {
    height: auto;
  }
}

.contact__text {
  margin-top: 16px;

  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #818C9D;
  line-height: 27px;
}

.contact__map {
  width: 765px;
  height: 502px;
  background: #FFFFFF;
  box-shadow: 0px 0px 13px 3px rgba(0, 0, 0, 0.08), 0px 3px 10px 0px rgba(100, 39, 8, 0.05);
  border-radius: 24px;
}

.contact__map-image {
  padding: 24px;
}

</style>
